import { Drawer } from "antd";
import { Sidebar } from "./Sidebar";
import type { MobileSidebarProps } from "../../types";

export function MobileSidebar({ open, onClose }: MobileSidebarProps) {
  return (
    <Drawer
      placement="left"
      open={open}
      onClose={onClose}
      width={180}
      styles={{
        body: { padding: 0 },
        header: { display: "none" },
      }}
      className="lg:hidden"
    >
      <Sidebar isMobile onClose={onClose} />
    </Drawer>
  );
}
